import { useCallback } from 'react';
import { DropResult } from 'react-beautiful-dnd';
import { ModuleStructure } from '../types';

export function useStructureDnD(
  modules: ModuleStructure[],
  onReorder: (updated: ModuleStructure[]) => void
) {
  const handleDragEnd = useCallback((result: DropResult) => {
    const { source, destination, type } = result;
    if (!destination) return;
    if (source.droppableId === destination.droppableId && source.index === destination.index) return;

    if (type === 'MODULE') {
      const updated = [...modules];
      const [moved] = updated.splice(source.index, 1);
      updated.splice(destination.index, 0, moved);
      onReorder(updated);
      return;
    }

    if (type === 'LESSON') {
      const sourceModuleIdx = parseInt(source.droppableId.replace('lessons-', ''), 10);
      const destModuleIdx = parseInt(destination.droppableId.replace('lessons-', ''), 10);

      const updated = modules.map((m) => ({ ...m, lessons: [...m.lessons] }));
      const [movedLesson] = updated[sourceModuleIdx].lessons.splice(source.index, 1);
      updated[destModuleIdx].lessons.splice(destination.index, 0, movedLesson);
      onReorder(updated);
    }
  }, [modules, onReorder]);

  return { handleDragEnd };
}
